<template>
    <actions-menu v-model:dialogDelete="dialog" :ShowDialogEdit="false" :ShowDialogConsult="true" :Id="Id"
        dialogConsult="ClientsDetails" :dialogConsultUrl="ClientId" :ShowDialogRefuse="isValidated"
        :ShowDialogValidation="isValidated" v-model:dialogRefuse="dialogCommentRefuse"
        v-model:dialogValidation="dialogValidation" :ShowDialogToCorrect="isValidated"
        v-model:dialogToCorrect="dialogCommentToCorrect"  :ShowDialogStatus="false"  v-model:dialogStatus="dialogStatus" :status="status" :-show-dialog-delete="false" />
    <v-dialog v-model="dialogCommentRefuse" v-if="dialogCommentRefuse">
        <v-card width="max-content" height="max-content" class="px-8 py-4">
            <div class="row justify-content-center">
                <v-card-title class="text-left">{{ $t("clients.validationTab.commentaireRefuser") }} :
                    <span class="red">*</span></v-card-title>
            </div>
            <div class="row justify-content-center">
                <v-textarea id="Comment" v-model="commentaireRefuse" variant="outlined" counter
                    :label="$t('clients.validationTab.commentaireLabel')" single-line auto-grow hide-details
                    maxlength="500"></v-textarea>
                <span class="warningHint" id="WarningMsgComment">{{
                    msg.refuseComment
                }}</span>
            </div>
            <div class="row justify-content-center">
                <card-actions :yes="RefuseCustomer" v-model:no="dialogCommentRefuse" width="200px"
                    :yesTitle="$t('clients.validationTab.refuseBtn')" :YesColor="'#F25C5C'" :loader="buttonLoader" />
            </div>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCommentToCorrect" v-if="dialogCommentToCorrect">
        <v-card width="max-content" height="max-content" class="px-8 py-4">
            <div class="row justify-content-center">
                <v-card-title class="text-left">{{ $t("clients.validationTab.commentaireToCorrect") }} :
                    <span class="red">*</span></v-card-title>
            </div>
            <div class="row justify-content-center mb-3">
                <v-textarea id="Comment" v-model="correctValues" variant="outlined" counter single-line auto-grow
                    hide-details maxlength="500" ></v-textarea>
                <span class="warningHint" id="WarningMsgComment">{{
                    msg.toCorrectComment
                }}</span>
            </div>
            <div class="row justify-content-center">
                <card-actions :yes="ToCorrectCustomer" v-model:no="dialogCommentToCorrect" width="200px"
                    :yesTitle="$t('clients.validationTab.toCorrectBtn')" :YesColor="'#F25C5C'" :loader="buttonLoader"/>
            </div>
        </v-card>
    </v-dialog>

    <dialogDelete DialogType="Refuse" :title="$t('clients.client')" :yes="RefuseCustomer" v-model="dialogRefuse" :loader="buttonLoader" />
    <dialogDelete DialogType="Validation" :title="$t('clients.client')" :yes="ValideCustomer"
        v-model="dialogValidation" :loader="buttonLoader" />
    <dialogDelete DialogType="ToCorrect" :title="$t('clients.client')" :yes="ToCorrectCustomer"
        v-model="dialogToCorrect" :loader="buttonLoader" />
    <dialogDelete :title="$t('clients.client')" :yes="DeleteCustomer" v-model="dialog" :loader="buttonLoader"   />
    <dialogDelete DialogType="Status" v-model="dialogStatus" :status="status" :yes="ChangeStatus" :loader="buttonLoader" /><!--status popup display-->
</template>
<script>
import { ChangeStatusOfCustomerByid, getClientsById, UpdateClientDeleteStatus } from "@/api";
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import CardActions from "@/genericComponent/cardActions.vue";
import DialogDelete from "@/genericComponent/dialogDelete.vue";


export default {
    name: "ClientItemMenu",
    components: { actionsMenu, DialogDelete, CardActions },
    props: {
        ClientId: {
            type: String,
            required: true,
        },
        isRestricted:{},
        isValidated: {},
        GetClientsAfterDeleted: {},
        Id: {},
        item: {},
        status: null
    },
    data() {
        return {
            dialog: false,
            validationStatus: 3,
            refuseStatus: 4,
            msg: [],
            correctValues: "",
            toCorrectStatus: 1,
            dialogCommentRefuse: false,
            dialogCommentToCorrect: false,
            commentaireRefuse: null,
            dialogRefuse: false,
            isDisabled: false,
            dialogToCorrect: false,
            dialogValidation: false,
            view: true,
            dialogStatus: false,
            buttonLoader: false 
        };
    },
    created() {
        const values = JSON.parse(localStorage.getItem(`toCorrect//${this.ClientId}`)) || [];
        if (values.length != 0) {
            let msg = "Please correct the following items and resubmit your data for verification : ";
            this.isDisabled = false;
            this.correctValues = msg + values.map(item => item).join(', ');
        }
    },
    methods: {
        ValideCustomer() {
            this.buttonLoader = true;
            ChangeStatusOfCustomerByid(this.ClientId, this.validationStatus).then(() => {
                this.GetClientsAfterDeleted();
            }).finally(() => {
                this.buttonLoader = false;
            });
        },
        DeleteCustomer() {
            getClientsById(this.ClientId).then((value) => {
                const item = value.data;
                item.isDeleted=true;
                UpdateClientDeleteStatus(item.idCustomer,item).then(()=>this.GetClientsAfterDeleted());
            }).catch((error) => {
                console.error("Error fetching client data: ", error);
            });
        },
        RefuseCustomer() {
            if (!this.commentaireRefuse) {
                this.msg.refuseComment = "Please provide a reason for the refusal";
            } else {
                this.buttonLoader = true;
                ChangeStatusOfCustomerByid(this.ClientId, this.refuseStatus,this.commentaireRefuse)
                    .then(() => {
                        this.GetClientsAfterDeleted();
                        this.msg.refuseComment = "";
                        this.commentaire = null;
                    })
                    .catch(error => {
                        console.error("Error updating customer status:", error);
                    }).finally(() => {
                        this.buttonLoader = false;
                    });
            }
        },
        ToCorrectCustomer() {
            if (this.correctValues !== "") {
                this.buttonLoader = true;
                ChangeStatusOfCustomerByid(this.ClientId, this.toCorrectStatus,this.correctValues).then(() => {
                    this.GetClientsAfterDeleted();
                    localStorage.removeItem(`toCorrect//${this.ClientId}`);
                    this.msg.toCorrectComment = "";
                    this.commentaire = null;
                }).finally(() => {
                    this.buttonLoader = false;
                });
            } else {
                this.msg.toCorrectComment = "Please select one or more fields to correct before updating";
            }
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        //popup status function 
        ChangeStatus() {
            /*ChangeStatusOfProductById(this.productId).then(() => {
                this.GetProductsAfterDeleted();
            });*/
        }
    }
};
</script>